import AlertBox from "@components/AlertBox/AlertBox"
import { getSplitDisbursementCount, isWithinCutOffTime, toCurrencyFormat } from "@lib/utils"
import { CutOffTime } from "../../types/redemption"
import { AlertContainer } from "./BankAlertBox.styles"
import { useTranslation } from "react-i18next"

type AlertProps = {
    payment?: boolean
    cutOffTime?: CutOffTime
    inputtedAmount: number
    splitDisbursementCountLimit: number
    maximumAmountPerDisbursement?: number
}

const BankAlertBox = ({
    payment,
    cutOffTime,
    inputtedAmount,
    splitDisbursementCountLimit,
    maximumAmountPerDisbursement
}: AlertProps) => {
    const { t } = useTranslation()
    const splitDisbursementCount = maximumAmountPerDisbursement ? getSplitDisbursementCount(inputtedAmount, maximumAmountPerDisbursement) : 1

    if (cutOffTime && isWithinCutOffTime(cutOffTime)) {
        return (
            <AlertContainer>
                <AlertBox 
                    alertText={t('bankAlert.cutOffTimeWarning')}
                />
            </AlertContainer>
        )
    }

    if (splitDisbursementCount > splitDisbursementCountLimit) {
        return (
            <AlertContainer>
                <AlertBox 
                    alertText={t('bankAlert.overMaximumSplitDisbursementsWarning', {
                        amount: toCurrencyFormat(maximumAmountPerDisbursement! * splitDisbursementCountLimit)
                    })}
                />
            </AlertContainer>
        )
    }

    if (splitDisbursementCount > 1) {
        return (
            <AlertContainer>
                <AlertBox 
                    alertText={t(payment ? 'bankAlert.partialPaymentWarning' : 'bankAlert.partialRedemptionWarning', {
                        count: splitDisbursementCount
                    })}
                />
            </AlertContainer>
        )
    }


    return null
}

export default BankAlertBox
